import { useNavigate } from 'react-router';
import { Button, Switch } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function CeldaSocioPost({ socio }) {

  const { t } = useTranslation();

  const navigate = useNavigate();
  return (
    <tr>
      <td className="col-sm px-sm-2">{socio.nombre}</td>
      <td className="col-sm px-sm-2">
      {!socio.coTitular ? t('HOLDER') : t('CO_HOLDER')}
      </td>
      <td className="col-sm px-sm-2">{socio.tipoCabana}</td>
      <td className="col-sm px-sm-2">{socio.membresia}</td>
      <td className="col-sm px-sm-2">{socio.fechaFirma.split('T')[0]}</td>
      <td className="col-sm px-sm-2">{socio.vecesMoroso}</td>
      <td className="col-sm px-sm-2">
        <Switch
          id="id"
          isChecked={socio.moroso}
          isDisabled={true}
        />
      </td>
      <td>
      <Button
          onClick={() => navigate(`/membresia/${socio.id}`)}
          ml={2}
          backgroundColor={'#e06c00'}
          color={'white'}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#d65f00')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#e06c00')}
        >
          {t('VIEW_MEMBERSHIP')}
        </Button>
      </td>
    </tr>
  );
}
